// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root___DsSg","buttons":"SendReceipts_buttons__3_47S","email":"SendReceipts_email__s3Wq7","bookApptTitle":"SendReceipts_bookApptTitle__3L86O"};